/* import __COLOCATED_TEMPLATE__ from './icon-arrow-next.hbs'; */
import SvgIcon from './svg-icon';
export default SvgIcon.extend({
  width: 18,
  height: 18,
  viewBox: '0 0 16 16',
  classNames: ['svg-icon--arrow-next']
});